import React from 'react'
import PropTypes from 'prop-types'
import { enUS } from 'date-fns/locale'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import theme from './theme'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { CookiesProvider } from 'react-cookie'
import { CsrfProvider } from './utils/context/CsrfContext'
import { AuthProvider } from './utils/context/AuthContext'
import { ModalProvider } from './utils/context/ModalContext'
import HarborCsThemeProvider from './utils/context/HarborCsThemeProvider'
import { NavigationHistoryProvider } from './utils/context/NavigationHistoryContext'
import SearchContext from './components/Search/SearchContext'
import ErrorBoundary from './components/ErrorBoundary'
import GlobalContactForm from './components/ContactForm/GlobalContactForm'

const WrapRootElement = ({ element }) => (
  <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={enUS}>
        <CssBaseline />
        <CookiesProvider>
          <CsrfProvider>
            <AuthProvider>
              <ModalProvider>
                <HarborCsThemeProvider>
                  <NavigationHistoryProvider>
                    <SearchContext.DiscoveryEngineProvider>
                      <GlobalContactForm>{element}</GlobalContactForm>
                    </SearchContext.DiscoveryEngineProvider>
                  </NavigationHistoryProvider>
                </HarborCsThemeProvider>
              </ModalProvider>
            </AuthProvider>
          </CsrfProvider>
        </CookiesProvider>
      </LocalizationProvider>
    </ThemeProvider>
  </ErrorBoundary>
)

WrapRootElement.propTypes = {
  element: PropTypes.node,
}

export default WrapRootElement
